import { i18next } from '@/i18n'
import axios from 'axios'
import { authHeader } from '@/services/auth'

export default {
  namespaced: true,
  state: {
    posts: [],
    urls: [],
    quotaMax: 0,
    nbClapRestants: 0,
    nbClapGeneres: 0,
    clapInProgress: false
  },
  actions: {
    checkQuotaClap (context, args) {
      const { universe, possedeClap } = args
      if (possedeClap) {
        let url = processEnvConfig.VUE_APP_UBIFLOW_API_URL + '/diffusion_annonceur?' + 'diffuseur-codeNames=' + `CLAP_VIDEO_${universe}`
        if (i18next.language != null) {
          url += '&lang=' + i18next.language
        }
        return axios.get(url, { headers: authHeader() }).then((response) => {
          const diffusionClap = response.data
          if (diffusionClap) {
            const diffusionAnnonceurClapVideo = response.data._embedded.diffusion_annonceur
            if (diffusionAnnonceurClapVideo[0].identifiants[4].valeur) {
              context.commit('setQuotaMax', diffusionAnnonceurClapVideo[0].identifiants[4].valeur)
            }
            if (diffusionAnnonceurClapVideo[0].identifiants[5].valeur) {
              context.commit('setNbClapRestants', diffusionAnnonceurClapVideo[0].identifiants[5].valeur)
            }
            if (diffusionAnnonceurClapVideo[0].identifiants[6].valeur) {
              context.commit('setNbClapGeneres', diffusionAnnonceurClapVideo[0].identifiants[6].valeur)
            }
          }
        })
      }
    }
  },
  mutations: {
    setPostStatus (state, post) {
      if (post) {
        const arrayUrls = state.posts
        const existPost = arrayUrls.filter((item) => item.id === post.id)
        if (existPost.length === 0) {
          state.posts.push(post)
        }
      }
    },
    setUrlClap (state, post) {
      if (post) {
        const arrayUrls = state.urls
        const existUrl = arrayUrls.filter((item) => item.annonceId === post.id)
        if (existUrl.length === 0) {
          const clapAnnonce = { annonceId: post.id, url: post.url_clap }
          state.urls.push(clapAnnonce)
        }
      }
    },
    deletePost (state, post) {
      state.clapInProgress = false
      const existPost = state.posts.findIndex((item) => item.id === post.id)
      state.posts.slice(existPost)
    },
    setQuotaMax (state, value) {
      state.quotaMax = value
    },
    setNbClapRestants (state, value) {
      state.nbClapRestants = value
    },
    setNbClapGeneres (state, value) {
      state.nbClapGeneres = value
    },
    setClapInProgress (state, value) {
      state.clapInProgress = value
    }
  },
  getters: {
    getHasPost: (state) => (post) => {
      return state.posts.find((item) => item.id == post.id)
    },
    getListPostsClap: (state) => state.posts,
    getPostClap: (state) => (post) => {
      return state.posts.filter((item) => item.id == post.id)
    },
    getQuotaMax: (state) => state.quotaMax,
    getNbClapRestants: (state) => state.nbClapRestants,
    getNbClapGeneres: (state) => state.nbClapGeneres,
    getHasUrlClap: (state) => (id) => {
      return state.urls.filter((item) => item.annonceId === id)
    },
    getClapInProgress: (state) => state.clapInProgress
  }
}
